module.exports = require("@swa-ui/itinerary/src/FlightInvalid/FlightInvalid.module.scss");